import { Component, Input, OnInit } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { Goal } from '@models/performance/goal.model';
import { GoalUpdate } from '@models/performance/goal-update.model';

const metricSymbols: Record<'percent' | 'dollar' | 'number', string> = {
    dollar: '$',
    percent: '%',
    number: '#',
} as const;

const getSuffixSymbol = (goal: Goal): string => {
    return metricSymbols[goal.metricType] || '';
};

enum ProgressStatuses {
    onTrack,
    behind,
    aheadOfSchedule,
}

@Component({
    selector: 'app-form-goal-update',
    templateUrl: './goal-update.template.html',
})
export class GoalUpdateForm extends BaseForm implements OnInit {
    @Input() goal: Goal;
    @Input() update: GoalUpdate;

    progressStatuses = ProgressStatuses;
    progressStatus: ProgressStatuses = ProgressStatuses.onTrack;
    actionType: 'add' | 'reset' = 'add';
    suffixSymbol: string;

    ngOnInit(): void {
        if (this.goal.metricType === 'binary') {
            this.update.metricIncrement = false;
            this.update.metricTotal = true;
        }

        this.suffixSymbol = getSuffixSymbol(this.goal);
    }

    updateIncrementToggle(): void {
        this.update.metricIncrement = true;
        this.update.metricTotal = false;
    }

    updateTotalToggle(): void {
        this.update.metricIncrement = false;
        this.update.metricTotal = true;
    }

    updateToggleOffTrack(): void {
        this.update.offTrack = true;
        this.update.progressing = false;
        this.update.onTrack = false;
    }

    updateProgressingTrack(): void {
        this.update.offTrack = false;
        this.update.progressing = true;
        this.update.onTrack = false;
    }

    updateToggleOnTrack(): void {
        this.update.offTrack = false;
        this.update.progressing = false;
        this.update.onTrack = true;
    }
}
